import { useState, useEffect } from 'react';
import { useMsci, useEvent } from '@/store';
import useBoletiaConfig from './useBoletiaConfig';
import { isEnded } from '@/locales/dates';

import { formatLocalDate } from '@/locales/dates';

export default function useMsciBanner() {
  const [bannerKind, setBannerKind] = useState('mci');
  const [bannerDetails, setBannerDetails] = useState(false);
  const [bannerData, setBannerData] = useState([]);

  const {
    event: {
      event: { id },
      gateway,
    },
  } = useEvent();

  const { isEventWithSaleLabel } = useBoletiaConfig();

  const {
    msci: { preSale, msi, preSaleMsi },
  } = useMsci();

  const getBannerTexts = (kind) => {
    if (kind === 'preSaleMsi') {
      return {
        title: `${
          isEventWithSaleLabel(id) ? 'Venta' : 'Preventa'
        } Exclusiva con ${Object.keys(preSale.banks)[0]}`,
        description: `Hasta ${Math.max(
          ...preSaleMsi.options,
        )} MSI con tarjetas participantes`,
        detailsTitle: 'Preventa exclusiva',
      };
    }
    if (kind === 'preSale') {
      return {
        title: `${isEventWithSaleLabel ? 'Venta' : 'Preventa'} Exclusiva con ${
          Object.keys(preSale.banks)[0]
        }`,
        description: `Hasta ${formatLocalDate(preSale.endAt, {
          dayName: false,
        })}`,
        detailsTitle: 'Preventa exclusiva',
      };
    }
    if (kind === 'msi') {
      return {
        title: `Paga en meses sin intereses ${
          gateway === 'ORKESTA_PAY' ? ' o con pagos fijos' : ''
        }`,
        description:
          'MSI válido con tarjetas de crédito de bancos participantes',
        detailsTitle: 'Meses sin intereses',
      };
    }
    if (gateway === 'ORKESTA_PAY') {
      return {
        title: 'Paga tus boletos a meses fijos',
        description: 'Válido con tarjetas de crédito de bancos participantes.',
      };
    }

    return {
      title: null,
      description: null,
    };
  };

  const closeBannerDetails = () => {
    setBannerDetails(false);
  };

  const openBannerDetails = () => {
    setBannerDetails(true);
  };

  useEffect(() => {
    if (preSaleMsi && !isEnded(preSaleMsi?.endAt)) {
      setBannerKind('preSaleMsi');
      setBannerData(preSaleMsi);
      return;
    }
    if (preSale && !isEnded(preSale?.endAt)) {
      setBannerKind('preSale');
      setBannerData(preSale);
      return;
    }
    if (msi && !isEnded(msi?.endAt)) {
      setBannerKind('msi');
      setBannerData(msi);
      return;
    }
  }, []);

  return {
    bannerData,
    bannerKind,
    bannerTexts: getBannerTexts(bannerKind),
    bannerDetails,
    closeBannerDetails,
    openBannerDetails,
  };
}
